import "./RichestPeopleCard.css";
import { escapeWealthHtml as esc, formatWealthValue as worth, wealthPersonImage, type WealthResponse } from "./WealthTypes";

export function renderRichestPeopleCard(container: HTMLElement, data: WealthResponse): void {
  const items = Array.isArray(data.items) ? data.items : [];
  const mode = items[0]?.classification?.presentation_mode || "compact_ai";
  const modeClass = `wealth-mode-${String(mode).replace(/[^a-z0-9_-]+/gi, "-")}`;
  container.innerHTML = `
    <section class="wealth-richest-card ${modeClass}">
      <div class="wealth-kicker">AYESEARCH WEALTH INTELLIGENCE</div>
      <h1>${esc(data.title || "Richest people")}</h1>
      <div class="wealth-richest-list">
        ${items.map((person, index) => `
          <article class="wealth-richest-row">
            <div class="wealth-richest-rank">${person.rank ? `#${person.rank}` : index + 1}</div>
            <div class="wealth-richest-image">${wealthPersonImage(person)}</div>
            <div class="wealth-richest-copy">
              <strong>${esc(person.name)}</strong>
              <span>${esc(person.source_of_wealth || person.country || "")}</span>
              ${person.about ? `<p>${esc(person.about)}</p>` : ""}
            </div>
            <div class="wealth-richest-worth">${esc(person.estimated_wealth_text || worth(person.net_worth_usd))}</div>
          </article>
        `).join("")}
      </div>
      <div class="wealth-source">
        <span>Curated by AyeSearch</span>
        ${data.source?.url ? `<a href="${esc(data.source.url)}" target="_blank" rel="noopener noreferrer">${esc(data.source.name || "Source")}</a>` : ""}
      </div>
    </section>
  `;
}
